import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./ncts-t1-section.css";

const NctsT1Section = () => {
  const { t } = useTranslation();
  
  // State for accordion sections
  const [expandedSections, setExpandedSections] = useState({
    nctsWhat: true,
    ctcCountries: false,
    nctsImportance: false,
    t1Benefits: true,
    t1Preparation: false
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <div className="nctsT1Container" id="NCTS">
      {/* Header Section */}
      <div className="nctsHeaderSection">
        <h2 className="nctsSectionTitle">NCTS</h2>
      </div>

      {/* Row: NCTS and T1 */}
      <div className="nctsRow">
        {/* NCTS Section */}
        <div className="nctsCard nctsCardLeft">
          <div className="cardHeaderMain">
            <div className="cardIconWrapper">
              <svg className="cardMainIcon" width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M9 11H3v2h6v-2zm0-4H3v2h6V7zm0 8H3v2h6v-2zm12-8h-6v2h6V7zm0 4h-6v2h6v-2zm0 4h-6v2h6v-2z" fill="currentColor"/>
              </svg>
            </div>
            <div>
              <h2 className="cardMainTitle">{t("nctsTitle")}</h2>
              <p className="cardIntroText">{t("nctsIntro")}</p>
            </div>
          </div>

          {/* Accordion Section 1 - What is NCTS */}
          <div className="accordionSection">
            <button 
              className={`accordionHeader ${expandedSections.nctsWhat ? '' : ''}`}
              onClick={() => toggleSection('nctsWhat')}
            >
              <span className="accordionTitle">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="accordionIcon">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" fill="currentColor"/>
                </svg>
                {t("nctsWhat")}
              </span>
              <svg className={`chevronIcon ${expandedSections.nctsWhat ? 'rotate' : ''}`} width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M7 10l5 5 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            <div className={`accordionContent ${expandedSections.nctsWhat ? 'expanded' : ''}`}>
              <div className="accordionInner">
                <p className="sectionDescription">{t("nctsDescription")}</p>
                <div className="modernList">
                  <div className="listItem">
                    <span className="listIcon">→</span>
                    <span>{t("nctsMovement1")}</span>
                  </div>
                  <div className="listItem">
                    <span className="listIcon">→</span>
                    <span>{t("nctsMovement2")}</span>
                  </div>
                  <div className="listItem">
                    <span className="listIcon">→</span>
                    <span>{t("nctsMovement3")}</span>
                  </div>
                  <div className="listItem">
                    <span className="listIcon">→</span>
                    <span>{t("nctsMovement4")}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Accordion Section 2 - CTC Countries */}
          <div className="accordionSection">
            <button 
              className={`accordionHeader ${expandedSections.ctcCountries ? 'active' : ''}`}
              onClick={() => toggleSection('ctcCountries')}
            >
              <span className="accordionTitle">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="accordionIcon">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="currentColor"/>
                </svg>
                {t("ctcCountriesTitle")}
              </span>
              <svg className={`chevronIcon ${expandedSections.ctcCountries ? 'rotate' : ''}`} width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M7 10l5 5 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            <div className={`accordionContent ${expandedSections.ctcCountries ? 'expanded' : ''}`}>
              <div className="accordionInner">
                <p className="sectionDescription">{t("ctcCountriesIntro")}</p>
                <div className="countryGrid">
                  <div className="countryTag">{t("ctcCountryEU")}</div>
                  <div className="countryTag">{t("ctcCountrySwitzerland")}</div>
                  <div className="countryTag">{t("ctcCountryNorway")}</div>
                  <div className="countryTag">{t("ctcCountryIceland")}</div>
                  <div className="countryTag">{t("ctcCountryMacedonia")}</div>
                  <div className="countryTag">{t("ctcCountrySerbia")}</div>
                  <div className="countryTag">{t("ctcCountryTurkey")}</div>
                  <div className="countryTag">{t("ctcCountryUK")}</div>
                  <div className="countryTag special">{t("ctcCountryGeorgia")}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Accordion Section 3 - NCTS Importance */}
          <div className="accordionSection">
            <button 
              className={`accordionHeader ${expandedSections.nctsImportance ? 'active' : ''}`}
              onClick={() => toggleSection('nctsImportance')}
            >
              <span className="accordionTitle">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="accordionIcon">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="currentColor"/>
                </svg>
                {t("nctsImportanceTitle")}
              </span>
              <svg className={`chevronIcon ${expandedSections.nctsImportance ? 'rotate' : ''}`} width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M7 10l5 5 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            <div className={`accordionContent ${expandedSections.nctsImportance ? 'expanded' : ''}`}>
              <div className="accordionInner">
                <div className="benefitsGrid">
                  <div className="benefitCard">
                    <div className="benefitIcon">📋</div>
                    <h4 className="benefitTitle">{t("nctsSimplification")}</h4>
                    <p className="benefitDesc">{t("nctsSimplificationDesc")}</p>
                  </div>
                  <div className="benefitCard">
                    <div className="benefitIcon">🛡️</div>
                    <h4 className="benefitTitle">{t("nctsControl")}</h4>
                    <p className="benefitDesc">{t("nctsControlDesc")}</p>
                  </div>
                  <div className="benefitCard">
                    <div className="benefitIcon">⚡</div>
                    <h4 className="benefitTitle">{t("nctsSpeed")}</h4>
                    <p className="benefitDesc">{t("nctsSpeedDesc")}</p>
                  </div>
                  <div className="benefitCard">
                    <div className="benefitIcon">✨</div>
                    <h4 className="benefitTitle">{t("nctsEfficiency")}</h4>
                    <p className="benefitDesc">{t("nctsEfficiencyDesc")}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* T1 Section */}
        <div className="nctsCard nctsCardRight">
          <div className="cardHeaderMain">
            <div className="cardIconWrapper yellow">
              <svg className="cardMainIcon" width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z" fill="currentColor"/>
              </svg>
            </div>
            <div>
              <h2 className="cardMainTitle">{t("t1FormTitle")}</h2>
              <p className="cardIntroText">{t("t1FormDesc")}</p>
            </div>
          </div>

          {/* T1 Benefits */}
          <div className="accordionSection">
            <button 
              className={`accordionHeader ${expandedSections.t1Benefits ? 'active' : ''}`}
              onClick={() => toggleSection('t1Benefits')}
            >
              <span className="accordionTitle">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="accordionIcon">
                  <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" fill="currentColor"/>
                </svg>
                {t("t1BenefitsTitle") || "T1 Benefits"}
              </span>
              <svg className={`chevronIcon ${expandedSections.t1Benefits ? 'rotate' : ''}`} width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M7 10l5 5 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            <div className={`accordionContent ${expandedSections.t1Benefits ? 'expanded' : ''}`}>
              <div className="accordionInner">
                <div className="checkList">
                  <div className="checkItem">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="checkIcon">
                      <circle cx="12" cy="12" r="10" fill="#10B981" fillOpacity="0.2"/>
                      <path d="M8 12l2 2 4-4" stroke="#10B981" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    <span>{t("t1Benefit1")}</span>
                  </div>
                  <div className="checkItem">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="checkIcon">
                      <circle cx="12" cy="12" r="10" fill="#10B981" fillOpacity="0.2"/>
                      <path d="M8 12l2 2 4-4" stroke="#10B981" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    <span>{t("t1Benefit2")}</span>
                  </div>
                  <div className="checkItem">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="checkIcon">
                      <circle cx="12" cy="12" r="10" fill="#10B981" fillOpacity="0.2"/>
                      <path d="M8 12l2 2 4-4" stroke="#10B981" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    <span>{t("t1Benefit3")}</span>
                  </div>
                  <div className="checkItem">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="checkIcon">
                      <circle cx="12" cy="12" r="10" fill="#10B981" fillOpacity="0.2"/>
                      <path d="M8 12l2 2 4-4" stroke="#10B981" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    <span>{t("t1Benefit4")}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* T1 Preparation */}
          <div className="accordionSection">
            <button 
              className={`accordionHeader ${expandedSections.t1Preparation ? 'active' : ''}`}
              onClick={() => toggleSection('t1Preparation')}
            >
              <span className="accordionTitle">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="accordionIcon">
                  <path d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z" fill="currentColor"/>
                </svg>
                {t("t1PreparationTitle")}
              </span>
              <svg className={`chevronIcon ${expandedSections.t1Preparation ? 'rotate' : ''}`} width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M7 10l5 5 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            <div className={`accordionContent ${expandedSections.t1Preparation ? 'expanded' : ''}`}>
              <div className="accordionInner">
                <p className="sectionDescription">{t("t1PreparationDesc")}</p>
                <div className="requirementsList">
                  <div className="requirementItem">
                    <span className="requirementNumber">1</span>
                    <span>{t("t1Requirement1")}</span>
                  </div>
                  <div className="requirementItem">
                    <span className="requirementNumber">2</span>
                    <span>{t("t1Requirement2")}</span>
                  </div>
                  <div className="requirementItem">
                    <span className="requirementNumber">3</span>
                    <span>{t("t1Requirement3")}</span>
                  </div>
                  <div className="requirementItem">
                    <span className="requirementNumber">4</span>
                    <span>{t("t1Requirement4")}</span>
                  </div>
                </div>
                <div className="recommendationBox">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="infoIcon">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" fill="#F59E0B"/>
                  </svg>
                  <p className="italic">{t("t1Recommendation")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Conclusion */}
      {/* <div className="nctsConclusion">
        <div className="conclusionContent">
          <h2>{t("nctsConclusion")}</h2>
          <p>{t("nctsConclusionText")}</p>
        </div>
      </div> */}
    </div>
  );
};

export default NctsT1Section;